import { useQuery } from '@tanstack/react-query';
import { ApiResponse, ListTemplates } from '@/types';
import apiClient from '@/utils/apiClient';

export const useListTemplates = () => {
    return useQuery({
        queryKey: ['listTemplates'],
        queryFn: async () => {
            const response = await apiClient.get<ApiResponse<ListTemplates[]>>('/surveys/templates');
            return response.data.data;
        },
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });
};
